import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../../../styles/Notes.module.css';
import { faArrowDownWideShort, faArrowUpShortWide, faFilter, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Button, Col, ListGroup, Row, Spinner } from 'react-bootstrap';
import React, { useCallback, useEffect, useState } from 'react';
import useApi from '../../../hooks/use-api';
import NonExpandableSearchBox from '../../../components/nonexpandablesearchbox';
import ButtonOverride from '../../../components/buttonoverride';
import _ from 'lodash';
import debounce from 'lodash.debounce';
import NotesInboxSkeleton from '../../../components/skeletons/notesinboxskeleton';
import NotesComposeSkeleton from '../../../components/skeletons/notescomposeskeleton';
import { Controller, useForm } from 'react-hook-form';
import RHFButtonListSelect from '../../../rhf/rhfbuttonlistselect';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { parse, isDate } from "date-fns";
import NotesPartialSkeleton from '../../../components/skeletons/notespartialskeleton';
import useMessageHub from '../../../hooks/use-messagehub';
import useUserStore from '../../../stores/user-store';
import { useOutletContext } from 'react-router-dom';


const Notes = ({noteLabel,getAllEndpoint,getSingleEndpoint,AddEndpoint,UpdateEndpoint,permissionbase,afterHoursWorkFlow = false}) => {
    const {ApplicationID: ApplicationId} = useOutletContext();
    const [selectedNote,setSelectedNote] = useState(null);
    const [noteTypes,setNoteTypes] = useState([]);
    const [noteAudiences,setNoteAudiences] = useState([]);
    const [noteAfterHours,setNoteAfterHours] = useState([]);
    const [notes,setNotes] = useState([]);
    const [refreshing,setRefreshing] = useState(true);
    const [noteRefreshing,setNoteRefreshing] = useState(false);
    const [editWindowRefreshing,seteditWindowRefreshing] = useState(false);
    const [refreshError,setRefreshError] = useState(false);
    const [showFiltering,setShowFiltering] = useState(false);

    const {registerActivity} = useMessageHub();
    const permissions = useUserStore((state) => state.permissions);
    const userid = useUserStore((state) => state.userid);

    const addNotePermission = `Application.${permissionbase}.AddNote`;
    const updateOwnPermission = `Application.${permissionbase}.UpdateOwn`;
    const updateAllPermission = `Application.${permissionbase}.UpdateAll`;

    const _permissionCheck = (permissionString) => permissions.includes(permissionString);
    const _updateDisabled = (selectedNoteId) => {
        if(selectedNoteId === null){
            return false;
        }
        else{
            const foundNote = notes.find(note => note.id === selectedNoteId);

            if(foundNote){
                if(foundNote.createdbyuser !== userid){
                    //Note created by someone else
                    return !_permissionCheck(updateAllPermission);
                }
                else{
                    //Self created note.
                    return !_permissionCheck(updateOwnPermission) && !_permissionCheck(updateAllPermission);
                }
            }

            return false;
        }
    }

    const initialFilterValues = {
        searchterm: '',
        types: [],
        audiences: [],
        orderbydatedesc: true,
        orderbydateasc: false
    }

    const [filters,setFilters] =  useState({
        searchterm: '',
        types: [],
        audiences: [],
        orderbydatedesc: true,
        orderbydateasc: false
    })

    const _setSearchTerm = (newSearchTerm) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            searchterm: newSearchTerm
        }));
    };

    const {processing,error,getRequestArray,getRequest,postRequest,putRequest} = useApi();

    const _refreshFull = async() => {
        setRefreshing(true);

        const [data,status] = await getRequest('NoteDefinitions',{timestamp: Date.now()}); 

        if(status === 200){
            setNoteTypes(data.noteTypes);
            setNoteAudiences(data.noteAudiences);
            setNoteAfterHours(data.afterHours);
            setRefreshing(false);
            setRefreshError(false);
        }
        else{
            setNoteTypes([]);
            setNoteAudiences([]);
            setNoteAfterHours([]);
            setRefreshing(false);
            setRefreshError(true);
        }
    }

    const _refreshNotes = async(filterValues) => {
        setNoteRefreshing(true);
        const [data, status] = await getRequestArray(getAllEndpoint, {ApplicationID: ApplicationId,Types: filterValues.types, Audiences: filterValues.audiences,SearchTerm: filterValues.searchterm,DateDescending: filterValues.orderbydatedesc, DateAscending: filterValues.orderbydateasc,timestamp: Date.now()}); 

        if (status === 200) {
            setNotes(data);
            setNoteRefreshing(false);
            setRefreshError(false);
        }
        else{
            setNotes([]);
            setNoteRefreshing(false);
            setRefreshError(true);
        }
    }

    const _debouncedRefreshNotes = useCallback(
        debounce((filterValues) => {
            _refreshNotes(filterValues);
        },250),[]
    )

    useEffect(() => {
        _refreshFull();
    },[])
      
    useEffect(() => {
        _debouncedRefreshNotes(filters);

        return () => {_debouncedRefreshNotes.cancel();}
    },[filters,_debouncedRefreshNotes])

    const _addNoteClick = () => {
        setSelectedNote(null);

        if(afterHoursWorkFlow){
            reset(initialValuesWithAfterHours);
        }
        else{
            reset(initialvalues);
        }
    }

    const _setFormValues = (data) => {
        // setValue("audiences",data.audiences);
        // setValue("enddate",data.enddate);
        // setValue("note",data.note);
        // setValue("startdate",data.startdate);
        // setValue("type",data.type);
        // setValue("afterhours",data.afterhours);

        if(afterHoursWorkFlow){
            let dataValues = {
                type: data.type,
                startdate: data.startdate,
                enddate: data.enddate,
                audiences: data.audiences ?? [],
                afterhours: data.afterhours,
                afterhourstypeid: data.afterhourstypeid === '' || data.afterhourstypeid === null ? initialValuesWithAfterHours.afterhourstypeid : data.afterhourstypeid,
                afterhourstypeother: data.afterhourstypeother === '' || data.afterhourstypeother === null ? initialValuesWithAfterHours.afterhourstypeother : data.afterhourstypeother,
                note: data.note
            }

            console.log(dataValues);
    
            reset(dataValues);
        }
        else{
            let dataValues = {
                type: data.type,
                startdate: data.startdate,
                enddate: data.enddate,
                audiences: data.audiences ?? [],
                note: data.note
            }
    
            reset(dataValues);
        }
    }

    const _handleNoteClick = async(noteID) => {
        setSelectedNote(noteID);
        seteditWindowRefreshing(true);
        const [data,status] = await getRequest(getSingleEndpoint,{ApplicationID: ApplicationId,NoteID: noteID ,timestamp: Date.now()})

        if(status == 200){
            if(data.afterhourstypeid === null)
                data.afterhourstypeid = initialValuesWithAfterHours.afterhourstypeid;
            _setFormValues(data);
            seteditWindowRefreshing(false);
        }
        else{
            seteditWindowRefreshing(false);
        }
    }

    const _handleFilterTypeClick = (id) => {
        setFilters((prevFilters) => {
            const { types } = prevFilters;
            if (types.includes(id)) {
              return {
                ...prevFilters,
                types: types.filter((existingId) => existingId !== id)
              };
            } else {
              return {
                ...prevFilters,
                types: [...types, id]
              };
            }
          });
    }

    const _handleFilterAudienceClick = (id) => {
        setFilters((prevFilters) => {
            const { audiences } = prevFilters;
            if (audiences.includes(id)) {
              return {
                ...prevFilters,
                audiences: audiences.filter((existingId) => existingId !== id)
              };
            } else {
              return {
                ...prevFilters,
                audiences: [...audiences, id]
              };
            }
          });
    }

    const _handleOrderingClick = () => {
        setFilters(prevFilters => ({
            ...prevFilters,
            orderbydatedesc: !prevFilters.orderbydatedesc,
            orderbydateasc: !prevFilters.orderbydateasc
        }));
    }

    function parseDateString(value, originalValue) {
        const parsedDate = isDate(originalValue)
          ? originalValue
          : parse(originalValue, "yyyy-MM-dd", new Date());
        return parsedDate;
      }

    const validationSchema = Yup.object().shape({
        startdate: Yup
          .date()
          .typeError("*Start date is required.")
          .required('*Start date is required.')
          .transform(parseDateString)
          .max(new Date().toISOString().split('T')[0], '*Start date cannot be in the future'),
        enddate: Yup
          .date()
          .typeError("*End date is required.")
          .required("*End date is required.")
          .transform(parseDateString)
          .max(new Date().toISOString().split('T')[0], '*End date cannot be in the future')
          .test('is-greater', '*End date cannot be before start date', function(value) {
            const { startdate } = this.parent;
            return !startdate || !value || value >= startdate;
          }),
        type: Yup.number().required("*You must select a Type."),
        audiences: Yup
          .array()
          .of(Yup.number().required())
          .min(1, "*You must select at least one Audience.")
          .required("*You must select at least one Audience."),
        note: Yup.string().required("*Required")
      });

      const initialvalues = {
        type: null,
        startdate: '',
        enddate: '',
        audiences: [],
        // afterhours: false,
        note: ''
    }

    const initialValuesWithAfterHours = {
        type: null,
        startdate: '',
        enddate: '',
        audiences: [],
        afterhours: false,
        afterhourstypeid: '',
        afterhourstypeother: '',
        note: ''
    }

    const { control,register,reset, handleSubmit,watch,setValue, resetField,formState: {errors,isDirty,isSubmitting} } = useForm({resolver: yupResolver(validationSchema),defaultValues: afterHoursWorkFlow ? initialValuesWithAfterHours : initialvalues});

    const onSubmit = async(values) => {
        if (selectedNote !== null){
            //Edit Mode
            const submitValues = {
                ...values,
                ApplicationID: ApplicationId,
                NoteID: selectedNote,
                type: values.type,
                audiences: values.audiences,
                startdate: values.startdate.toISOString().split('T')[0],
                enddate: values.enddate.toISOString().split('T')[0]
            }
            
            if(afterHoursWorkFlow){
                if(submitValues.afterhourstypeid === '')
                    submitValues.afterhourstypeid = null;
                if(submitValues.afterhourstypeother === '')
                    submitValues.afterhourstypeother = null;
            }

            const [data,status] = await putRequest(UpdateEndpoint,{...submitValues});

            if(status === 200){
                registerActivity(
                    {
                        body: "Note Updated",
                        errorFlag: false
                    },
                    true,
                    true
                )

                _refreshNotes(filters);
                _setFormValues(data);
            }
            else{
                registerActivity(
                    {
                        body: "Failed to update Note.",
                        errorFlag: true
                    },
                    true,
                    true
                )
            }

        }
        else{
            const submitValues = {
                ...values,
                ApplicationID: ApplicationId,
                type: values.type,
                audiences: values.audiences,
                startdate: values.startdate.toISOString().split('T')[0],
                enddate: values.enddate.toISOString().split('T')[0]
            }

            if(afterHoursWorkFlow){
                if(submitValues.afterhourstypeid === '')
                    submitValues.afterhourstypeid = null;
                if(submitValues.afterhourstypeother === '')
                    submitValues.afterhourstypeother = null;
            }

            const [data,status] = await postRequest(AddEndpoint,{...submitValues});

            if(status === 201){
                registerActivity(
                    {
                        body: "Note Added",
                        errorFlag: false
                    },
                    true,
                    true
                )

                _refreshNotes(filters);
                if(!afterHoursWorkFlow)
                    _setFormValues(initialvalues);
                else
                    _setFormValues(initialValuesWithAfterHours);
            }
            else{
                registerActivity(
                    {
                        body: "Failed to add Note.",
                        errorFlag: true
                    },
                    true,
                    true
                )
            }
        }
    };

    const afterhoursTrue = watch('afterhours');
    const afterhoursSelected = watch('afterhourstypeid');
    const afterhoursFollowupRequired = afterHoursWorkFlow & afterhoursSelected !== undefined & noteAfterHours.find(opt => opt.id === afterhoursSelected)?.hasfollowup;
    const filteredTypes = noteTypes.filter(type => filters.types.includes(type.id));
    const filteredAudiences = noteAudiences.filter(audience => filters.audiences.includes(audience.id));
    const hasActiveFilters = (filteredAudiences.length + filteredTypes.length > 0) || (filters.searchterm !== '');

    useEffect(() => {
        if(afterHoursWorkFlow){
            if(!selectedNote){
                if(!afterhoursTrue){
                    resetField('afterhourstypeid',{defaultValue: initialValuesWithAfterHours.afterhourstypeid});
                    resetField('afterhourstypeother',{defaultValue: initialValuesWithAfterHours.afterhourstypeother});
                }
                else if(!afterhoursFollowupRequired){
                    resetField('afterhourstypeother',{defaultValue: initialValuesWithAfterHours.afterhourstypeother});
                }
            }
            else{
                if(!afterhoursTrue){
                    resetField('afterhourstypeid');
                    resetField('afterhourstypeother');

                    setValue('afterhourstypeid',initialValuesWithAfterHours.afterhourstypeid);
                    setValue('afterhourstypeother',initialValuesWithAfterHours.afterhourstypeother);
                }
                else if(!afterhoursFollowupRequired){
                    // setValue('afterhourstypeother',initialValuesWithAfterHours.afterhourstypeother);
                    // resetField('afterhourstypeother');resetField('afterhourstypeother');

                    resetField('afterhourstypeother');

                    setValue('afterhourstypeother',initialValuesWithAfterHours.afterhourstypeother);
                }
            }
            
        }
    },[afterHoursWorkFlow,afterhoursTrue,afterhoursFollowupRequired])

    // useEffect(() => {
    //     if(afterHoursWorkFlow && !afterhoursTrue){
    //         setValue('afterhourstypeid',initialValuesWithAfterHours.afterhourstypeid);
    //         setValue('afterhourstypeother',initialValuesWithAfterHours.afterhourstypeother);
    //     }
    // },[afterhoursTrue,afterHoursWorkFlow])

    // useEffect(() => {

    //     const selectedNote = noteAfterHours.find((item) => item.id === afterhoursSelected);

    //     if(selectedNote && !selectedNote.hasfollowup){
    //         setValue('afterhourstypeother',initialValuesWithAfterHours.afterhourstypeother);
    //     }
    // },[afterhoursSelected,afterHoursWorkFlow])
    return(
        <Row>
            <Col xs={12} md={4} className='mb-4'>
            {
                refreshing
                ?
                    <NotesInboxSkeleton itemCount={5}/>
                :
                <div className={`clientCard ${styles.noteListCard}`}>
                <div className={styles.noteItemHeader}>
                <h4 className={`mb-0`}>
                    {noteLabel}
                </h4>
                {
                    selectedNote !== null
                    ?
                        <Button type="button" variant='success' title='Add Note' aria-label='Add Note' className={styles.noteListItemAddButton} onClick={_addNoteClick}>
                            <FontAwesomeIcon icon={faPlus} size='xl' />
                        </Button>
                    :
                        null
                }
                </div>
                <div className={styles.noteItemFilterBody}>
                    <div className='d-flex align-items-center'>
                        <div className={styles.flexGrowExtra}>
                        <NonExpandableSearchBox
                            size="1"
                            id="notesearch"
                            placeholder="Search..."
                            searchTerm={filters.searchterm}
                            setSearchTerm={_setSearchTerm}
                            value={filters.searchterm}
                            onChange={e => { _setSearchTerm(e.target.value);}}
                            containerStyle={{ width: '100%' }}
                        />
                        </div>
                        <Button style={{borderRadius: '50%'}} type='button' variant={`${filters.audiences.length > 0 || filters.types.length > 0 ? 'primary' : 'secondary'}`} aria-label='Filtering' title='Filtering' size='sm' className={`${styles.flexGrowFull} ms-1`} onClick={() => setShowFiltering(!showFiltering)}>
                            <FontAwesomeIcon icon={faFilter} size='lg'/>
                        </Button>
                    </div>
                    {
                        showFiltering && 
                        <div className={styles.filterBody}>
                            <div className='d-flex justify-content-between align-items-center mb-2'>
                                <strong className={styles.filterHeader}>Current Filters</strong>
                                {
                                    hasActiveFilters
                                    ?
                                        <Button type='button' variant='secondary' size='sm' onClick={() => setFilters(initialFilterValues)}>Clear Filters</Button>
                                    :
                                        <small>No active filters</small>
                                }
                            </div>
                            {
                                hasActiveFilters
                                ?
                                    <div className='mb-3'>
                                        {
                                            filteredTypes.length > 0
                                            ?
                                                <div>
                                                    <strong>Types:</strong> {filteredTypes.map(item => item.name).join(', ')}
                                                </div>
                                            :
                                                null
                                        }
                                        {
                                            filteredAudiences.length > 0
                                            ?
                                                <div>
                                                    <strong>Audiences:</strong> {filteredAudiences.map(item => item.name).join(', ')}
                                                </div>
                                            :
                                                null
                                        }
                                        <div>
                                            <strong>Ordering:</strong> {filters.orderbydateasc ? 'Date Ascending' : filters.orderbydatedesc ? 'Date Descending' : 'None'}
                                        </div>
                                        {
                                            filters.searchterm !== ''
                                            ?
                                                <div>
                                                    <strong>Search Term:</strong> {filters.searchterm}
                                                </div>
                                            :
                                                null
                                        }
                                    </div>
                                :
                                    null
                            }
                            <div className='d-flex justify-content-center'>
                                <strong className={styles.filterHeader}>Filter By Type</strong>
                            </div>
                            <div className={styles.filterDialogBody}>
                                {
                                    noteTypes.length &&
                                    noteTypes.map((item) => (
                                        <ButtonOverride key={item.id} className={`${styles.filterDialogSelectBtn} ${filters.types.includes(item.id) ? styles.active : null}`} onClick={() => _handleFilterTypeClick(item.id)}>
                                            {item.name}
                                        </ButtonOverride>
                                    ))
                                }
                            </div>
                            <div className='d-flex justify-content-center'>
                                <strong className={styles.filterHeader}>Filter By Audience</strong>
                            </div>
                            <div className={styles.filterDialogBody}>
                                {
                                    noteAudiences.length &&
                                    noteAudiences.map((item) => (
                                        <ButtonOverride key={item.id} className={`${styles.filterDialogSelectBtn} ${filters.audiences.includes(item.id) ? styles.active : null}`} onClick={() => _handleFilterAudienceClick(item.id)}>
                                            {item.name}
                                        </ButtonOverride>
                                    ))
                                }
                            </div>
                        </div>
                    }
                    <div className='d-flex justify-content-between align-items-center mt-2'>
                        <span>
                            {
                                hasActiveFilters
                                ?
                                    <Button type='button' variant='link' className='p-0' style={{textDecoration: 'none'}} size='sm' onClick={() => setShowFiltering(true)}>
                                        Filters applied
                                    </Button>
                                :
                                    <small>No active filters</small>
                            }
                        
                        </span>
                        <div className='d-flex justify-content-between align-items-center'>
                            <Button style={{borderRadius: '50%',marginRight: '4px'}} type='button' variant={`${filters.orderbydateasc ? 'primary' : 'secondary'}`} title='Order by Date Ascending' aria-label="Order by Date Ascending" size='sm' onClick={_handleOrderingClick}>
                                {/* <FontAwesomeIcon icon={faArrowUpWideShort} /> */}
                                <FontAwesomeIcon icon={faArrowUpShortWide} />
                            </Button>
                            <Button style={{borderRadius: '50%'}} type='button' variant={`${filters.orderbydatedesc ? 'primary' : 'secondary'}`} title='Order by Date Descending' aria-label="Order by Date Descending" size='sm' onClick={_handleOrderingClick}>
                                {/* <FontAwesomeIcon icon={faArrowDownShortWide} /> */}
                                <FontAwesomeIcon icon={faArrowDownWideShort} />
                            </Button>
                        </div>
                    </div>
                </div>
                {
                    noteRefreshing
                    ?
                        <NotesPartialSkeleton itemCount={3}/>
                    :
                    <div className={styles.noteList}>
                        <ListGroup>
                    {
                        // sampleNotes.map((item) => (
                        //     <ListGroup.Item action className={styles.noteListItem} type='button' aria-label='View Note' active={item.id === selectedNote} onClick={() => setSelectedNote(item.id)}>
                        //         <span className={styles.noteListItemRow}>
                        //             <span>{item.user}</span>
                        //             <span>{item.date}</span>
                        //         </span>
                        //         <span className={styles.noteListItemRow}>fdsfdsfsdfd</span>
                        //     </ListGroup.Item>
                        // ))
                        notes.length > 0
                        ?
                            notes.map((item) => (
                                <ListGroup.Item key={item.id} action className={styles.noteListItem} type='button' aria-label='View Note' active={item.id === selectedNote} onClick={() => _handleNoteClick(item.id)}>
                                    <span className={styles.noteListItemRow}>
                                        <span>{item.name}</span>
                                        <span>{item.date}</span>
                                    </span>
                                    <span className={styles.noteListItemRow}>
                                        <span className={styles.noteListItemText}>{item.body}</span>
                                    </span>
                                    <span className={styles.noteListItemRow}>
                                        <span className={`${styles.noteListItemType} ${selectedNote == item.id ? styles.active : null}`}>
                                            {`${item.type} (${item.audiences.join(', ')})`}
                                        </span>
                                    </span>
                                </ListGroup.Item>
                            ))
                        :
                            _.isEqual(filters,initialFilterValues)
                            ?
                                <div className='text-center mb-2 mt-2'>No Notes Currently Exist.</div>
                            :
                                <div className='text-center mb-2 mt-2'>No Notes Found.</div>
                    }
                </ListGroup>
                    </div>
                }
            </div>
            }
            </Col>
            <Col xs={12} md={8} >
            {
                refreshing || editWindowRefreshing
                ?
                    <NotesComposeSkeleton typeCount={5} audienceCount={9} />
                :
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='clientCard'>
                        <div className={styles.noteViewerBody}>
                            <h4>{selectedNote !== null ? <>Edit Note</> : <>Add Note</>}</h4>
                            <div>
                                <Row>
                                    <Col xs={12} md={6} className='mb-2'>
                                        <label htmlFor='startdate'>Start Date</label>
                                        <input style={{width: '100%'}} type='date' id='startdate' {...register("startdate")} max={new Date().toISOString().split('T')[0]} disabled={(selectedNote === null ? !_permissionCheck(addNotePermission) : _updateDisabled(selectedNote)) || isSubmitting}/>
                                        {errors.startdate ? <small style={{color: 'red'}}>{errors.startdate.message}</small> : null}
                                                {/* <InputField
                                                    type="date"
                                                    name="startdate"
                                                    label="Start Date"
                                                    max={new Date().toISOString().split('T')[0]}
                                                    margin='mb-1'
                                                /> */}
                                    </Col>
                                    <Col xs={12} md={6} className='mb-2'>
                                        <label htmlFor='enddate'>End Date</label>
                                        <input style={{width: '100%'}} type='date' id='enddate' {...register("enddate")} max={new Date().toISOString().split('T')[0]} disabled={(selectedNote === null ? !_permissionCheck(addNotePermission) : _updateDisabled(selectedNote)) || isSubmitting}/>
                                        {errors.enddate ? <small style={{color: 'red'}}>{errors.enddate.message}</small> : null}
                                                {/* <InputField
                                                    type="date"
                                                    name="enddate"
                                                    label="End Date"
                                                    max={new Date().toISOString().split('T')[0]}
                                                    margin='mb-1'
                                                /> */}
                                    </Col>
                                    <Col xs={12} className='mb-2'>
                                                {/* <strong>Type</strong> */}
                                        <Controller
                                            name='type'
                                            control={control}
                                            // defaultValue={null}
                                            render={({ field }) => (
                                                <RHFButtonListSelect
                                                    options={noteTypes}
                                                    disabled={(selectedNote === null ? !_permissionCheck(addNotePermission) : _updateDisabled(selectedNote)) || isSubmitting}
                                                    label='Type'
                                                    {...field}
                                                    error={errors.type}
                                                />
                                            )}
                                        />
                                                {/* <div className={styles.filterDialogBody}>
                                                    {
                                                        noteTypes.map((item,index) => (
                                                            <ButtonOverride type='button' key={item.id} className={`${styles.filterDialogSelectBtn} ${filters.audiences.includes(item.id) ? styles.active : null}`} onClick={() => _handleFilterAudienceClick(item.id)}>
                                                                {item.name}
                                                            </ButtonOverride>
                                                        ))
                                                    }
                                                </div> */}
                                    </Col>
                                    <Col xs={12} className='mb-2'>
                                        <Controller
                                            name='audiences'
                                            control={control}
                                            // defaultValue={null}
                                            render={({ field }) => (
                                                <RHFButtonListSelect
                                                    options={noteAudiences}
                                                    disabled={(selectedNote === null ? !_permissionCheck(addNotePermission) : _updateDisabled(selectedNote)) || isSubmitting}
                                                    label='Audiences'
                                                    multiple
                                                    {...field}
                                                    error={errors.audiences}
                                                />
                                            )}
                                        />
                                    </Col>
                                    {
                                        afterHoursWorkFlow &&
                                        <>
                                            <Col xs={12}>
                                                <label>
                                                    <input type='checkbox' {...register("afterhours")} disabled={(selectedNote === null ? !_permissionCheck(addNotePermission) : _updateDisabled(selectedNote)) || isSubmitting}/>
                                                    After Hours Contact
                                                </label>
                                            </Col>
                                            {
                                                afterhoursTrue &&
                                                <>
                                                    <Col xs={12} md={6}>
                                                        <label htmlFor='afterhourstypeid'>After Hours Type</label>
                                                        <select id='afterhourstypeid' style={{width: '100%', height: '30px'}} {...register('afterhourstypeid')}>
                                                            <option value=''>--Select an after hours type--</option>
                                                            {
                                                                noteAfterHours.map((item) => (
                                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                                ))
                                                            }
                                                        </select>
                                                    </Col>
                                                    <Col xs={12} md={6}>
                                                        {
                                                            afterhoursSelected && noteAfterHours.find(item => item.id === afterhoursSelected)?.hasfollowup
                                                            ?
                                                                <>
                                                                    <label htmlFor='afterhoursother'>Other</label>
                                                                    <input type='text' id='afterhoursother' {...register('afterhourstypeother')} style={{width : '100%'}}/>
                                                                </>
                                                            :
                                                                null
                                                        }
                                                    </Col>
                                                </>
                                            }
                                        </>
                                    }
                                    {/* <Col xs={12}>
                                        <label>
                                            <input type='checkbox' {...register("afterhours")} disabled={(selectedNote === null ? !_permissionCheck(addNotePermission) : _updateDisabled(selectedNote)) || isSubmitting}/>
                                            After Hours Contact
                                        </label>
                                    </Col> */}
                                    {/* {
                                        afterHoursWorkFlow && afterhoursTrue
                                        ?
                                            afterhoursTrue
                                            ?
                                            <>
                                                <Col xs={12} md={6}>
                                                    <label htmlFor='afterhourstypeid'>After Hours Type</label>
                                                    <select id='afterhourstypeid' style={{width: '100%', height: '30px'}} {...register('afterhourstypeid')}>
                                                        <option value='-1'>--Select an after hours type--</option>
                                                        {
                                                            noteAfterHours.map((item) => (
                                                                <option key={item.id} value={item.id}>{item.name}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </Col>
                                                <Col xs={12} md={6}>
                                                    {
                                                        afterhoursSelected && noteAfterHours.find(item => item.id === afterhoursSelected)?.hasfollowup
                                                        ?
                                                            <>
                                                                <label htmlFor='afterhoursother'>Other</label>
                                                                <input type='text' id='afterhoursother' {...register('afterhoursother')} style={{width : '100%'}}/>
                                                            </>
                                                        :
                                                            null
                                                    }
                                                </Col>
                                            </>
                                            :
                                                null
                                        :
                                            null
                                    } */}
                                    <Col xs={12} className='mt-2'>
                                    <div className={errors.note ? styles.error : null}>
                                        <label style={{width: '100%'}} htmlFor='note'>
                                            Note
                                            {errors.note ? <small style={{color: 'red'}}>{errors.note.message}</small> : null}
                                        </label>
                                        <textarea style={{width: '100%'}} rows={14} id='note' {...register("note")} disabled={(selectedNote === null ? !_permissionCheck(addNotePermission) : _updateDisabled(selectedNote)) || isSubmitting}/>
                                    </div>
                                            {/* <FloatLabel
                                        type="text"
                                        as="textarea"
                                        name="note"
                                        label="Note"
                                        placeholder="Email"
                                        autoComplete="offz"
                                        style={{height: '400px'}}
                                    /> */}
                                    </Col>
                                    <Col xs={12}>
                                    <div className='d-flex justify-content-end mb-1 mt-1'>
                                    {
                                        selectedNote === null
                                        ?
                                            _permissionCheck(addNotePermission)
                                            ?
                                                <Button type='submit' variant="primary" title='Submit' aria-label='Submit' disabled={!isDirty || isSubmitting } >
                                                    {
                                                        isSubmitting
                                                        ?
                                                            <Spinner animation='border' size='sm' />
                                                        :
                                                            <>Submit</>
                                                    }
                                                </Button>
                                            :
                                                <small style={{color: 'red'}}>*You currently do not have permissions to add a note.</small>
                                        :
                                            !_updateDisabled(selectedNote)
                                            ?
                                                <Button type='submit' variant="primary" title='Submit' aria-label='Submit' disabled={!isDirty || isSubmitting } >
                                                    {
                                                        isSubmitting
                                                        ?
                                                            <Spinner animation='border' size='sm' />
                                                        :
                                                            <>Submit</>
                                                    }
                                                </Button>
                                            :
                                                <small style={{color: 'red'}}>*You currently do not have permissions to edit this note.</small>
                                    }
                                    </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </form>
            }
            </Col>
        </Row>
    )
}

export default Notes;
